import { Field } from 'formik'
import { FC } from 'react'
import styles from './index.module.scss'

export const TotalCampaignBudgetField: FC = () => {
  return (
    <div className={styles.container}>
      <label className={styles.radio}>
        <Field type='radio' name='budget' value='Less than $10,000' />
        Less than $10,000
      </label>
      <label className={styles.radio}>
        <Field type='radio' name='budget' value='$10,0000 - $50,000' />
        $10,0000 - $50,000
      </label>
      <label className={styles.radio}>
        <Field type='radio' name='budget' value='$50,000 - $100,000' />
        $50,000 - $100,000
      </label>
      <label className={styles.radio}>
        <Field type='radio' name='budget' value='More than $100,000' />
        More than $100,000
      </label>
    </div>
  )
}
